import { defineStore } from 'pinia'
import { reactive } from 'vue'

import { Contact } from '@/shared/types/api'

export const useStoreWaitingApprove = defineStore('waiting-approve', () => {
  const waitingApprovePSTNGuests = reactive(new Map<string, Map<string, Contact>>())

  const getWaitingApprovePSTNGuestsByRoomId = (roomId: string) => {
    return waitingApprovePSTNGuests.get(roomId) ?? new Map<string, Contact>()
  }

  const setWaitingApprovePSTNGuests = (roomId: string, map: Map<string, Contact>) => {
    waitingApprovePSTNGuests.set(roomId, map)
  }

  const deletePSTNGuestFromRoom = (roomId: string, contactId: string) => {
    const map = waitingApprovePSTNGuests.get(roomId)
    map?.delete(contactId)
  }

  return {
    waitingApprovePSTNGuests,
    getWaitingApprovePSTNGuestsByRoomId,
    setWaitingApprovePSTNGuests,
    deletePSTNGuestFromRoom,
  }
})
